// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__31RjO","card":"About_card__1PSYp"};